import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Pagination from '../../components/Pagination';

import { Link } from 'react-router-dom';

import moment from "moment";
import 'moment/locale/pt-br';
import '../../../node_modules/react-vis/dist/style.css';

import Header from '../../components/Header';
import ModalRegion from '../../components/modals/ModalRegion';
import InputDate from '../../components/inputs/InputDate';

import bag2 from '../../assets/images/bag.svg';
import search from '../../assets/images/search.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';
import polygonUp from '../../assets/images/polygonUp.svg';
import polygonDown from '../../assets/images/polygonDown.svg';
import api from '../../services/api';
import axios from 'axios';
import { Loading } from '../../components/ResponsiveLoading';
import { createUrlParamsFromObject, getRegionFromUrl, getUrlParam } from '../../services/helpers';
import getUserInfo from '../../services/getUserInfo';

export const Managers = () => {
  const [showRegions, setShowRegions] = useState(false);
  const [filter, setFilter] = useState({});
  const [region, setRegion] = useState({});
  const [updateFilter, setUpdateFilter] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [gerentes, setGerentes] = useState([]);
  const [searchInput, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);

  const [sortBy, setSortBy] = useState(getUrlParam('sort_by') ?? 'checkins');
  const [sortDir, setSortDir] = useState(getUrlParam('sort_dir') ?? 'desc');

  const [userInfo, setUserInfo] = useState({});

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
    });


    let urlStartDate = getUrlParam('start_date');
    let urlFinalDate = getUrlParam('final_date');

    let toStartDate = urlStartDate ? new Date(urlStartDate+'T00:00:00') : new Date();
    let toFinalDate = urlFinalDate ? new Date(urlFinalDate+'T00:00:00') : new Date();
    let toRegion = getRegionFromUrl();
    
    setStartDate(toStartDate);
    setFinalDate(toFinalDate);
    setRegion(toRegion);

    let filters = {
      date_start: moment(toStartDate).format('YYYY-MM-DD'),
      date_end: moment(toFinalDate).format('YYYY-MM-DD'),
      regional_id: toRegion?.id ?? null
    }

    setLoading(true);
    getGerentes(filters);
    setFilter(filters);
  }, []);

  useEffect(() => {
    if(gerentes.length > 0){
      setLoading(true);
      getGerentes(filter);
    }
  }, [updateFilter, page, sortBy, sortDir]);

  useEffect(() => {
    updateUrlParams();
  }, [sortBy, sortDir, region, startDate, finalDate]);

  const updateUrlParams = () => {
    const params = {
      sort_by: sortBy,
      sort_dir: sortDir,
      start_date: moment(startDate).format('YYYY-MM-DD'),
      final_date: moment(finalDate).format('YYYY-MM-DD')
    };

    if(Object.keys(region).length > 0){
      params.region_id = region.id;
      params.region_nome = region.nome;
      params.region_slug = region.slug;
    }

    const urlParams = createUrlParamsFromObject(params);
    
    window.history.replaceState(null, null, `${window.location.pathname}?${urlParams}`);
  }

  const getGerentes = async (filters = {}) => {
    if (typeof cancelToken != typeof undefined) {
      window.cancelToken.cancel()
    }

    window.cancelToken = axios.CancelToken.source();

    const { data, status } = await api.get(`gerentes`, {
      params: { 
        ...filters,
        page,
        sort_by: sortBy,
        sort_dir: sortDir
      },
      cancelToken: window.cancelToken.token
    });

    if (status === 200) {
      setGerentes(data.gerentes);
      setPageCount(data._pagination.last_page);
      setLoading(false);
    } else {
      setLoading(false);
    }
  }

  const handleRegion = (region) => {
    setRegion(region);
    setShowRegions(false);
    let cFilter = filter;
    cFilter.regional_id = region.id;
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }
  const handleDate = (start, final) => {
    let cFilter = filter;
    cFilter.date_start = moment(start).format('YYYY-MM-DD');
    cFilter.date_end = moment(final).format('YYYY-MM-DD');
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
    setStartDate(start);
    setFinalDate(final);
  }
  const handleGerente = (e) => {
    setSearch(e.target.value);
    setPage(1);
    let cFilter = filter;
    cFilter.busca = e.target.value;
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }

  const changeOrder = (e, by) => {
    e.preventDefault();
    
    if(sortBy === by){
      setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(by);
      setSortDir('desc');
    }
  }

  const ColumnTitle = ({name, value}) => {
    return (
      <a href="#" onClick={e => changeOrder(e, value)}>{name}
        <div className="orderBy">
          {((sortDir === 'asc' && sortBy === value) || sortBy !== value) &&
            <img src={polygonUp} />
          }
          {((sortDir === 'desc' && sortBy === value) || sortBy !== value) &&
            <img src={polygonDown} />
          }
        </div>
      </a>
    );
  }

  return (
    <>
      {showRegions &&
        <ModalRegion handleClose={() => setShowRegions(false)} handleRegion={handleRegion} />
      }

      <section id="content">
        <Header 
          icon={<img src={bag2} />} 
          title="Gerentes"
          area="gerentes" 
          showDownload={true} 
        />
        <div className="pd-37">
        <div className="box-header">
          <div className="box-tools">
            {userInfo?.isMaster &&
              <button className="btn-filter btn-box-shadow" style={{ minWidth: 180 }} onClick={() => setShowRegions(true)}>
                {loading &&
                  <Loading cWidth={120} cHeight={40} />
                }
                {!loading &&
                  <>
                    <img src={icon[region.slug] ?? br} />
                    <span>{region.nome ?? 'Brasil'}</span>
                  </>
                }
              </button>
            }
            <InputDate cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />

            <Form className="form-search">
              <Form.Control className="btn-filter btn-box-shadow" id="btn-search" type="text" value={searchInput} onChange={handleGerente} placeholder="BUSCAR GERENTE" />
              <img src={search} />
            </Form>
          </div>
        </div>
        <Row>
          <Col sm={9}>
            <div className="box-body">
              <Row>
                <Col sm={12}>
                  <div className="box-card h-full">
                    <div className="box-card-noPadding">
                      <table className="table-dash table-border">
                        <thead>
                          <tr className="light-blue">
                            <th>
                              <ColumnTitle value="apelido" name="Gerente" />
                            </th>
                            <th>
                              <ColumnTitle value="superintendente" name="Super" />
                            </th>
                            <th>
                              <ColumnTitle value="checkins" name="Check-ins" />
                            </th>
                            <th>
                              <ColumnTitle value="atendimentos" name="Atendimentos" />
                            </th>
                            <th style={{ borderRadius: 0 }}>
                              <ColumnTitle value="vendas" name="Assinaturas" />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading && gerentes.map((gerente, key) => (
                            <tr key={key}>
                              <td><Link to={`/managers/${gerente.id}`}>{gerente.apelido}</Link><div className="state">{gerente.regional.slug}</div></td>
                              <td>{gerente.superintendente ? gerente.superintendente.apelido : `-`}</td>
                              <td>{gerente.total.checkins}</td>
                              <td>{gerente.total.atendimentos}</td>
                              <td>{gerente.total.vendas}</td>
                            </tr>
                          ))}
                          {loading &&
                            <tr>
                              <td colSpan={5}>Carregando...</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              <Pagination
                page={page}
                setPage={setPage}
                pageCount={pageCount}
              />
            </div>
          </Col>
        </Row>
        </div>
      </section>
    </>
  );

}

export default Managers;